import { Component, computed, input, InputSignal, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DsBreakpoints, DsButtonIntent, DsButtonVariants, DsTooltipPosition, Icons } from '@levelaccess/design-system';
import { AiChatStateService } from '../ai-chat/ai-chat-state.service';
import { WindowService } from '../../services/window.service';

@Component({
  selector: 'app-ai-chat-button',
  templateUrl: './ai-chat-button.component.html',
  standalone: false,
})
export class AiChatButtonComponent {
  readonly variant: InputSignal<DsButtonVariants> = input<DsButtonVariants>(DsButtonVariants.primary);
  readonly isIconOnly: InputSignal<boolean> = input<boolean>(false);

  protected readonly DsButtonIntent: typeof DsButtonIntent = DsButtonIntent;
  protected readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;
  protected readonly DsTooltipPosition: typeof DsTooltipPosition = DsTooltipPosition;
  protected readonly Icons: typeof Icons = Icons;

  private readonly isSmallViewport: Signal<boolean> = toSignal(this.windowService.observeBreakpoint(DsBreakpoints.Small), {
    initialValue: false,
  });

  protected readonly showAsIconOnly: Signal<boolean> = computed(() => this.isIconOnly() || this.isSmallViewport());

  constructor(
    private aiChatStateService: AiChatStateService,
    private windowService: WindowService,
  ) {}

  public toggleAiChat(): void {
    this.aiChatStateService.toggleAiChat();
  }
}
